// extracted by mini-css-extract-plugin
export var container = "Section-module--container--8ef09";
export var hasSpacer = "Section-module--hasSpacer--3d5b7";
export var hasSpacerLg = "Section-module--hasSpacerLg--87828";
export var heading = "Section-module--heading--24d5a";
export var inner = "Section-module--inner--ebf60";
export var isInnerOffsetY = "Section-module--isInnerOffsetY--25b75";
export var themeAlternate = "Section-module--themeAlternate--507bb";
export var themeBasic = "Section-module--themeBasic--04a6b";
export var themeDefault = "Section-module--themeDefault--8a909";
export var themeNavy = "Section-module--themeNavy--2edab";
export var themePlum = "Section-module--themePlum--f92dc";
export var themeTan = "Section-module--themeTan--d7fc6";
export var themeTanOffset = "Section-module--themeTanOffset--578f4";